import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';
import { BrandLogoFull as BrandLogoFullIcon } from '../../../components/Brand';
import { moduleBrokerName } from '../../../module-params';
import { brokersList } from '../../../helpers/brokers-list';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
    justifyContent: 'center',

    '& svg': {
      width: 'auto',
      height: '40px',

      [theme.breakpoints.up('md')]: {
        height: '45px',
      },
    },

    '& .MuiLink-root': {
      display: 'inline-flex',
    },
  },
  BrokerWiseLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .feat': {
      display: 'flex',
      justifyContent: 'center',
      margin: '0 10px',
      fontSize: 22,
      fontWeight: 600,
      color: '#7a7a7a',

      [theme.breakpoints.up('md')]: {
        margin: '0 20px',
        fontSize: 24,
      },
    },

    '& img': {
      height: 35,
      width: 'auto',
      display: 'flex',

      [theme.breakpoints.up('md')]: {
        height: '40px',
      },
    },
  },
}));

function getLogo() {
  const targetGetBroker = brokersList.find(
    (item) => item.name === moduleBrokerName
  )?.img;

  return targetGetBroker;
}

function BrokerWiseLogo() {
  const logo = getLogo();
  const classes = useStyles();

  if (!logo) {
    return <></>;
  }

  return (
    <div className={`${classes.BrokerWiseLogo} broker--${moduleBrokerName}`}>
      <div className="feat">/</div>
      <img src={logo} alt={moduleBrokerName} />
    </div>
  );
}

const BrokerWiseCrossAuthLogo = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Link href="https://quantiply.tech/" target="_blank">
        <BrandLogoFullIcon />
      </Link>
      <BrokerWiseLogo />
    </div>
  );
};

export default BrokerWiseCrossAuthLogo;
